require('../../../../../node_modules/intl-tel-input/build/css/intlTelInput.css');
require('./style.scss');

export const cameraAccessTemplate = function ({CAMERA_ACCESS_NEEDED}) {
    return '<div class="modal_camera_access">' +
        '<p class="modal_camera_access_block">' + CAMERA_ACCESS_NEEDED + '</p>';
}

